<template>
  <div style="position: relative;">
    <div>
      <div class="d-flex justify-content-between" style="margin-bottom: 1.70rem;">
        <div class="d-flex align-items-center" style="gap: 2.34rem;">
          <!-- <div>
            <h1 class="title">{{ $t("audit-finding.organization") }}</h1>
          </div> -->
          <div class="search2">
            <div class="search2--icon"><i class="iconoir-search"></i></div>
            <input v-model="nameFilter" class="search2--input" type="text" :placeholder="$t('common.search')" />
          </div>
        </div>

        <div class="d-flex align-items-center float-right ml-4" @click="toggleRightPanel">
          <div class="new-task-text">{{ $t("audit-finding.new") }}</div>
          <div class="plus-button" style="margin-right: 1.56rem;"></div>
        </div>
      </div>
      <div class="float-right">
        <right-panel id="sidebar-new-finding" width="1050px" @hidden="rightPanelClosed" :text="$t('audit-finding.finding.new')">
          <div class="pl-5 pr-5">
            <OrganizationFindingForm
              :hide-library="true"
              :closeOnSave="false"
              @onSave="paginate"
              ref="sidebar-new-finding"
              :allowedClass="allowedClass"
              :lockedClass="lockedClass"
              :finding="selectedFinding"
            />
          </div>
        </right-panel>
      </div>

      <nav class="tab-menu">
        <div
          :class="{ active: activeTab === 'ORGANIZATION_FINDINGS' }"
          @click="
            activeTab = 'ORGANIZATION_FINDINGS';
            if (!activeSubTab) activeSubTab = 'EVALUATION_PENDING';
          "
        >
          {{ $t("audit-finding.organization") }}
        </div>
        <div :class="{ active: activeTab === 'AWAITING_APPROVAL' }" @click="activeTab = 'AWAITING_APPROVAL'">
          {{ $t("audit-finding.status.awaiting_approvals") }}
        </div>
      </nav>

      <div class="mt-4">
        <!-- Sub-tabs for Organization Findings -->
        <div class="mb-4" v-if="activeTab === 'ORGANIZATION_FINDINGS'">
          <nav class="tab-menu">
            <div :class="{ active: activeSubTab === 'EVALUATION_PENDING' }" @click="activeSubTab = 'EVALUATION_PENDING'">
              {{ $t("audit-control.status.tab-evaluation-pending") }}
            </div>
            <div :class="{ active: activeSubTab === 'REJECTED' }" @click="activeSubTab = 'REJECTED'">
              {{ $t("audit-finding.status.rejected_evaluating") }}
            </div>
            <div :class="{ active: activeSubTab === 'ACTION_PLAN_MONITORING' }" @click="activeSubTab = 'ACTION_PLAN_MONITORING'">
              {{ $t("audit-finding.status.action_plan_continuing") }}
            </div>
            <div :class="{ active: activeSubTab === 'COMPLETED' }" @click="activeSubTab = 'COMPLETED'">
              {{ $t("audit-finding.status.completed") }}
            </div>
            <!-- <div :class="{ active: activeSubTab === 'PASSIVE' }" @click="activeSubTab = 'PASSIVE'">
              {{ $t("audit-finding.status.passive") }}
            </div> -->
            <div :class="{ active: activeSubTab === 'ALL' }" @click="activeSubTab = 'ALL'">
              {{ $t("audit-finding.all") }}
            </div>
          </nav>
        </div>

        <div class="d-flex flex-column">
          <div class="d-flex justify-content-end mb-3">
            <b-button variant="light" size="sm" class="text-info font-weight-bold" @click="showFilters = !showFilters">
              <i class="bx bx-filter"></i> {{ $t("common.filter") }}
            </b-button>
          </div>

          <div class="d-flex">
            <div v-if="showFilters" class="mr-3 border-right pr-3" style="width: 320px; flex-shrink: 0;">
              <OrganizationFindingFilterSidebar />
            </div>
            <div class="flex-grow-1" style="min-width: 0;">
              <content-loading v-if="isLoading" />
              <div v-else>
                <div v-if="activeSubTab !== 'ALL'">
                  <div v-if="pagination && pagination.docs" class="row">
                    <div :class="showFilters ? 'col-md-6 mb-4' : 'col-md-4 mb-4'" v-for="finding in pagination.docs" :key="finding._id">
                      <OrganizationFindingCard :finding="finding" @edit="edit" />
                    </div>
                  </div>
                </div>
                <OrganizationFindingList v-else :pagination="pagination" :isLoading="isLoading" @edit="edit" @delete="deleteById" />

                <empty v-if="!pagination || pagination.docs.length == 0">
                  <h5 class="text-center">
                    {{ $t("common.no-data") }}
                  </h5>
                </empty>

                <div v-if="pagination && pagination.docs.length > 0" class="row mt-4">
                  <div class="col">
                    <ul class="pagination pagination-rounded mb-0">
                      <b-pagination v-model="request.options.page" :total-rows="pagination.totalDocs" :per-page="pagination.limit" limit="10" size="sm"></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import OrganizationFindingForm from "./organization-finding-form.vue";
import OrganizationFindingList from "./organization-finding-list.vue";
import OrganizationFindingCard from "./organization-finding-card.vue";
import OrganizationFindingFilterSidebar from "./organization-finding-filter-sidebar.vue";

export default {
  components: { OrganizationFindingForm, OrganizationFindingList, OrganizationFindingCard, OrganizationFindingFilterSidebar },
  props: {
    allowedClass: {
      type: String,
      default: undefined,
    },
    lockedClass: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      nameFilter: undefined,
      noFilter: undefined,
      selectedFinding: null,
      request: {
        options: { page: 1, limit: 15, sort: { createdAt: "desc" } },
        query: {
          status: {
            value: { $in: ["APPROVED_EVALUATING", "EDIT_REQUESTED_EVALUATING"] },
            isObject: true,
          },
        },
      },
    };
  },
  created() {
    if (this.allowedClass) {
      this.request.query.class = { value: this.allowedClass, isObject: true };
    }
  },

  computed: {
    activeTab: {
      get() {
        return this.$store.getters["organizationFinding/activeTab"];
      },
      set(v) {
        this.$store.commit("organizationFinding/activeTab", v);
      },
    },
    activeSubTab: {
      get() {
        return this.$store.getters["organizationFinding/activeSubTab"];
      },
      set(v) {
        this.$store.commit("organizationFinding/activeSubTab", v);
      },
    },
    showFilters: {
      get() {
        return this.$store.getters["organizationFinding/showFilterSidebar"];
      },
      set(v) {
        this.$store.commit("organizationFinding/showFilterSidebar", v);
      },
    },
    pagination() {
      return this.$store.getters["organizationFinding/pagination"];
    },
    findingFilters() {
      return this.$store.getters["organizationFinding/findingFilters"] || {};
    },
    isLoading() {
      return this.$store.getters["organizationFinding/isLoading"];
    },
    activeStatus() {
      // fallback for legacy usage
      if (this.activeTab === "AWAITING_APPROVAL") return ["AWAITING_APPROVAL", "EXTENSION_APPROVAL"];
      return this.activeSubTab;
    },
    hasPermission() {
      return true; // Placeholder for actual permission check
    },
  },

  mounted() {
    this.updateQuery();
  },
  watch: {
    nameFilter(n) {
      if (n) {
        this.request.query = { ...this.request.query, name: { value: n } };
      } else {
        delete this.request.query["name"];
      }
      this.request.options.page = 1;
    },
    noFilter(n) {
      if (n) {
        this.request.query = { ...this.request.query, no: { value: n, isObject: true } };
      } else {
        delete this.request.query["no"];
      }
      this.request.options.page = 1;
    },
    activeTab() {
      this.updateQuery();
    },
    activeSubTab() {
      this.updateQuery();
    },
    findingFilters: {
      deep: true,
      handler() {
        this.request.options.page = 1;
        this.debounceMixin(() => this.paginate());
      },
    },
    request: {
      deep: true,
      immediate: true,
      handler() {
        this.debounceMixin(() => this.paginate());
      },
    },
    allowedClass: {
      immediate: true,
      handler(newValue) {
        const currentClass = newValue || "ALL_FINDINGS";
        const prevClass = this.$store.getters["organizationFinding/lastListClass"];

        if (prevClass && prevClass !== currentClass) {
          this.$store.commit("organizationFinding/findingFilters", {});
        }

        this.$store.commit("organizationFinding/lastListClass", currentClass);

        if (newValue) {
          this.request.query.class = { value: newValue, isObject: true };
        } else {
          delete this.request.query.class;
        }
        // this.paginate();
      },
    },
  },
  methods: {
    updateQuery() {
      const newQuery = { ...this.request.query };

      delete newQuery["status"];
      delete newQuery["approvals.assignee"];
      delete newQuery["approvals.active"];
      delete newQuery["approvals.0.status"];
      delete newQuery["approvals.0.assignee"];
      delete newQuery["approvals.0.assignee._id"];
      // delete newQuery["approvals.assignee"]; // Not seemingly used in this simplified refactor, but kept if needed in future
      // delete newQuery["approvals.active"];

      if (this.activeTab === "AWAITING_APPROVAL") {
        if (this.currentAccount) {
          newQuery.status = { value: { $in: ["AWAITING_APPROVAL", "EXTENSION_APPROVAL"] }, isObject: true };
          newQuery["approvals.0.assignee._id"] = { value: this.currentAccount._id, isObject: true };
          newQuery["approvals.0.status"] = { value: "PENDING", isObject: true };
        }
      } else {
        // Organization Findings Tab
        switch (this.activeSubTab) {
          case "EVALUATION_PENDING":
            newQuery.status = {
              value: { $in: ["APPROVED_EVALUATING", "EDIT_REQUESTED_EVALUATING"] },
              isObject: true,
            };
            break;
          case "REJECTED":
            newQuery.status = {
              value: "REJECTED_EVALUATING",
              isObject: true,
            };
            break;
          case "ACTION_PLAN_MONITORING":
            newQuery.status = { value: "ACTION_PLAN_MONITORING", isObject: true };
            break;
          case "COMPLETED":
            newQuery.status = { value: "COMPLETED", isObject: true };
            break;
          case "PASSIVE":
            newQuery.status = { value: "PASSIVE", isObject: true };
            break;
          case "ALL":
            // No status filter
            break;
        }
      }

      this.request.query = newQuery;
      this.request.options.page = 1;
    },
    displayDefinitions(array) {
      if (!array || !array.length) {
        return "";
      }
      return array.map((i) => i.name[this.currentLanguage]).join(", ");
    },
    toggleRightPanel() {
      this.selectedFinding = null;
      this.$store.commit("organizationFinding/editedEntity", undefined);
      this.$root.$emit("bv::toggle::collapse", "sidebar-new-finding");
    },
    rightPanelClosed() {
      this.selectedFinding = null;
      this.$store.commit("organizationFinding/editedEntity", undefined);
    },
    async paginate() {
      const mergedQuery = { ...this.request.query };
      for (const key of Object.keys(this.findingFilters)) {
        const val = this.findingFilters[key];
        if (val !== null && val !== undefined && val !== "") {
          if (["category", "type", "complianceGroup"].includes(key) && val._id) {
            mergedQuery[key] = { value: val._id, isObject: true };
          } else if (key === "complianceItemNo" && val && typeof val === "object" && val.name) {
            const strVal = val.name.tr || val.name.en || val.name;
            if (strVal) mergedQuery[key] = { value: strVal, isObject: true };
          } else {
            mergedQuery[key] = { value: val, isObject: true };
          }
        }
      }

      this.$store.commit("organizationFinding/isLoading", true);
      try {
        const mergedRequest = {
          options: this.request.options,
          query: mergedQuery,
        };
        await this.$store.dispatch("organizationFinding/fetchFilteredFindings", mergedRequest);
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      } finally {
        this.$store.commit("organizationFinding/isLoading", false);
      }
    },
    async edit(finding) {
      try {
        const { data } = await this.$store.dispatch("organizationFinding/findById", finding._id);
        this.selectedFinding = data;
        this.$store.commit("organizationFinding/editedEntity", data);
        this.$root.$emit("bv::toggle::collapse", "sidebar-new-finding");
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },
    async deleteById(id) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        await this.$store.dispatch(`organizationFinding/delete`, id);
        this.paginate();
        this.$toast.success(this.$t("common.delete-successful"));
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@modules/core/compliance-item/organization-policy.scss";
</style>
